import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { FlowDefinitionContext } from '../models/flow.model';
import { BaseService } from './base.service';
import { IBaseModel } from '../models/base.model';
import { firstValueFrom } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class FlowDefinitionContextService extends BaseService {
    controllerRoute = 'FlowDefinitionContext';

    constructor(httpClient: HttpClient) {
        super(httpClient);
    }

    public async getById(id: string): Promise<IBaseModel<FlowDefinitionContext>> {
        return await firstValueFrom(this.httpClient.get<IBaseModel<FlowDefinitionContext>>(`${this.apiBaseUrl}/${this.controllerRoute}/${id}`));
    }

    public async isContextInUse(id: string): Promise<IBaseModel<boolean>> {
        return await firstValueFrom(this.httpClient.get<IBaseModel<boolean>>(`${this.apiBaseUrl}/${this.controllerRoute}/IsContextInUse/${id}`));
    }
}
